import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from '../../axiosConfig';
import { endpoints } from '../../utils/constants';
import { sendLogger } from '../../utils/loggerUtils';
import { LogLevels } from '../../utils/enums';

export const getSession = createAsyncThunk('session/getSession', async (body, { dispatch }) => {
  try {
    const response = await axios.get(endpoints.SESSION);
    return response.data;
  } catch (error) {
    const errMsg = 'Error getting session: ' + error;
    sendLogger(dispatch, errMsg, LogLevels.ERROR)
    throw error;
  }
});

const sessionSlice = createSlice({
  name: 'session',
  initialState: {
    data: [],
    loading: 'idle',
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getSession.pending, (state) => {
        state.loading = 'loading';
      })
      .addCase(getSession.fulfilled, (state, action) => {
        state.loading = 'succeeded';
        state.data = action.payload;
      })
      .addCase(getSession.rejected, (state, action) => {
        state.loading = 'failed';
        state.error = action.error.message;
      });
  },
});

export default sessionSlice.reducer;
